var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Discover_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Discover_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.522.609.609 99.39h155.304V.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7622",
    d: "M155.652 55.652s-42.339 30.035-120 43.478h120z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M155.652.87v98.26H.87V.87zm.87-.87H0v100h156.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.652 30.609H7.217v22.608h6.435c3.392 0 5.913-.782 8.087-2.608a11.36 11.36 0 0 0 4.087-8.696c0-6.696-4.956-11.304-12.174-11.304m5.218 16.956c-1.392 1.218-3.218 1.826-6.087 1.826h-1.218V34.435h1.218c2.87 0 4.608.521 6.087 1.826a7.56 7.56 0 0 1 2.434 5.652 7.73 7.73 0 0 1-2.434 5.652M32.348 30.609h-4.435v22.608h4.435zM43.13 39.304c-2.608-.956-3.39-1.652-3.39-2.87 0-1.39 1.39-2.521 3.303-2.521a4.52 4.52 0 0 1 3.566 1.826l2.347-3.043a10.02 10.02 0 0 0-6.695-2.522c-4 0-7.044 2.782-7.044 6.522 0 3.13 1.392 4.695 5.566 6.174 1.054.335 2.073.772 3.043 1.304a2.76 2.76 0 0 1 1.304 2.348 3.25 3.25 0 0 1-3.39 3.217 5.09 5.09 0 0 1-4.784-3.043l-2.869 2.782c2 2.957 4.522 4.348 7.826 4.348 4.609 0 7.826-3.043 7.826-7.391-.087-3.652-1.652-5.305-6.608-7.13M51.044 41.913a11.75 11.75 0 0 0 11.913 11.826c1.932.016 3.84-.431 5.565-1.304v-5.218a7.02 7.02 0 0 1-5.305 2.435c-4.434 0-7.565-3.217-7.565-7.826a7.47 7.47 0 0 1 7.392-7.74c2.086 0 3.739.784 5.565 2.523V31.39A11.65 11.65 0 0 0 63.13 30a12.025 12.025 0 0 0-12.086 11.913M103.565 45.826 97.478 30.61h-4.782l9.565 23.217h2.435l9.739-23.217h-4.783zM116.435 53.217h12.522v-3.826h-8.087v-6.087h7.826v-3.826h-7.826v-5.043h8.087v-3.826h-12.522zM146.435 37.304c0-4.26-2.957-6.695-8-6.695h-6.522v22.608h4.435v-9.043h.609l6.087 9.13h5.391l-7.131-9.565c3.305-.695 5.131-2.956 5.131-6.435m-8.87 3.74h-1.304v-6.87h1.391c2.783 0 4.261 1.13 4.261 3.391s-1.478 3.479-4.348 3.479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF7622",
    d: "M94 41.913a12 12 0 1 1-12-12 12.026 12.026 0 0 1 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M148.783 31.044c0-.435-.261-.61-.783-.61h-.609v2h.435v-.782l.522.783h.609l-.696-.783a.555.555 0 0 0 .522-.608m-.783.26-.087-.521H148c.261 0 .348.086.348.26s-.174.261-.348.261"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M148.174 29.652a1.738 1.738 0 1 0 0 3.477 1.738 1.738 0 0 0 0-3.477m0 3.218a1.392 1.392 0 1 1 1.391-1.392 1.5 1.5 0 0 1-1.391 1.392"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h156.522v100H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h156.522v100H0z"
  })))));
};
export default SvgDiscover;